// src/utils.ts
function toKebabCase(str) {
  return str.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

export {
  toKebabCase
};
